{
    
    "title": "Applications",
    "download": "Download Applications",
    "search": "Search Application...",
    "board": {
        "name": "Name",
        "status": "Status",
        "type": "Type"
    },
    "status": {
        "readyforsubmission": "READY FOR SUBMISSION",
        "incomplete": "INCOMPLETE",
        "changesrequested": "CHANGES REQUESTED",
        "submitted": "SUBMITTED",
        "completed": "COMPLETED",
        "processing": "PROCESSING"
    }
}